<template>
  <countTo
    ref="countToRef"
    :startVal="startVal"
    :endVal="endVal"
    :duration="duration"
    :autoplay="autoplay"
    :decimals="decimals"
    :decimal="decimal"
    :separator="separator"
    :prefix="prefix"
    :suffix="suffix"
    :useEasing="useEasing"
    v-bind="$attrs"
  />
</template>

<script>
  import countTo from 'vue-count-to';
  export default {
    name: 'numberAnimation',
    components:{
      countTo,
    },
    props:{
      startVal: { // 开始值
        type: Number,
        default: 0,
      },
      endVal: { // 结束值
        type: Number,
        default: 0,
      },
      duration: { // 动画时长
        type: Number,
        default: 2000,
      },
      autoplay: { // 是否自动播放 (设置为true时，startVal或endVal变化时会自动播放)
        type: Boolean,
        default: true,
      },
      decimals: { // 要显示的小数位数
        type: Number,
        default: 0,
      },
      decimal: { // 小数点分割符
        type: String,
        default: '.',
      },
      separator: { // 千位分符
        type: String,
        default: ',',
      },
      prefix: { // 前缀
        type: String,
        default: '',
      },
      suffix: { // 后缀
        type: String,
        default: '',
      },
      useEasing: { // 是否使用缓动函数
        type: Boolean,
        default: true,
      },
    },
    methods: {
      start() { // 开始动画
        this.$refs.countToRef && this.$refs.countToRef.start();
      },
      pause() { // 暂停动画
        this.$refs.countToRef && this.$refs.countToRef.pause();
      },
      reset() { // 恢复动画
        this.$refs.countToRef && this.$refs.countToRef.reset();
      },
    },
  }
</script>

<style lang="scss" scoped></style>
